<template>
    <div class="markdown-content"  v-html="compiledMarkdown" contenteditable></div>
</template>

<script>
import { marked } from 'marked'

export default {
    props: {
        content: {
            type: String,
            required: true
        },
        contenteditable:{
            type:Boolean,
            default:true
        }
    },
    computed: {
        compiledMarkdown() {
            return marked(this.content)
        }
    },
}
</script>

<style lang="scss" scoped>
/* 可选：添加Markdown样式 */
.markdown-content {
    line-height: 1.2;
    border: none;
}

[contenteditable]:focus {
    outline: none;
}

.markdown-content strong {
    font-weight: bold;
}

.markdown-content em {
    font-style: italic;
}
</style>